<!--

  Implementation

  -in template:


  -import:

-->


<template>
  <v-form v-model="valid"
          ref="DialogForm">
    <slotted-dialog :title="'New support ticket'"
                    :externaltrigger="trigger"
                    :externalCloseTrigger="closetrigger"
                    @close="$emit('close')">
      <template v-slot:content>
        <area-li :label="'Subject'"
                 :value="'Error in ' + (errorlogg && errorlogg.Method ? errorlogg.Method : 'unknown method')"
                 :keyname="'Subject'"
                 :noempty="true"
                 :edit="true"
                 @fetch="updateValue"
                 :key="avoidduplicatekey(trigger, 1)">
        </area-li>

        <v-list-item v-if="errorlogg"
                     :key="avoidduplicatekey(trigger, 2)">
          <v-menu open-on-hover
                  bottom
                  :offset-y="true">
            <template v-slot:activator="{ on }">
              <v-chip class="white--text"
                      color="error"
                      v-on="on"
                      @click="() => { logerror(errorlogg); copyerror}">
                <v-icon class="mr-2">mdi-bug</v-icon>
                Errorlogg
              </v-chip>
            </template>

            <!-- v-menu content -->
            <v-container class="pa-0">
              <v-card width="468"
                      class="d-flex flex-column">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Route:</v-list-item-title>
                    <v-list-item-subtitle>{{errorlogg.Route ? errorlogg.Route : 'Not tracked'}}</v-list-item-subtitle>

                    <v-list-item-title>Failed method:</v-list-item-title>
                    <v-list-item-subtitle>{{errorlogg.Method ? errorlogg.Method : 'Not tracked'}}</v-list-item-subtitle>

                    <v-list-item-title>Input:</v-list-item-title>
                    <v-list-item-subtitle>{{errorlogg.Input ? errorlogg.Input : 'Not tracked'}}</v-list-item-subtitle>

                    <v-list-item-title>Response:</v-list-item-title>
                    <v-list-item-subtitle style="display: -webkit-box;
                                            max-width: 100%;
                                            -webkit-line-clamp: 10;
                                            -webkit-box-orient: vertical;
                                            overflow: hidden;
                                            white-space: pre-wrap;">
                      {{errorlogg.Response ? errorlogg.Response : 'Not tracked'}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-container>
          </v-menu>
        </v-list-item>

        <area-li :label="'Optional message'"
                 :value="null"
                 :keyname="'OptionalMessage'"
                 :edit="true"
                 @fetch="updateValue"
                 :key="avoidduplicatekey(trigger, 3)">
        </area-li>
        <switch-li v-if="isLoggedIn && userInfo && userInfo.EmailAdress"
                   :label="'Keep me updated'"
                   :value="true"
                   :keyname="'CCMe'"
                   :edit="true"
                   @fetch="updateValue">
        </switch-li>
        <area-li v-if="isLoggedIn && userInfo && userInfo.EmailAdress"
                 :label="'From'"
                 :value="userInfo && userInfo.EmailAdress ? userInfo.EmailAdress : 'Missing'">
        </area-li>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++"
               outlined
               color="primary"
               v-text="$t('servicesystem.common_objects.commonterms.close')">
        </v-btn>
        <v-btn @click="valid ? SendTicket(): null"
               :color="valid ? 'primary' : 'disabled'">Send ticket</v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";

export default {
  name: "TicketDialog",
  props: ["isLoggedIn", "externaltrigger", "externalCloseTrigger", "errorlogg"],
  components: { SlottedDialog, AreaLi, SwitchLi },
  mixins: [clientAPI],

  data() {
    return {
      trigger: 0,
      closetrigger: 0,
      valid: true,
      editObject: {},
    };
  },

  mounted() {},

  methods: {
    logerror(e) {
      console.error(e);
    },

    updateValue(update) {
      this.editObject[update.key] = update.value;
    },

    SendTicket() {
      this.createTicket(this.editObject).then(() => {
        this.closetrigger++;
      });
    },

    copyerror() {
      navigator.clipboard.writeText(this.errorlogg.Response.Data);
    },
  },

  computed: {},

  watch: {
    externaltrigger: function () {
      this.trigger++;
    },

    errorlogg: function () {
      this.editObject.ErrorLogg = this.errorlogg;
    },
  },
};
</script>